<template>
  <section class="c-personal-info">
    <b-row align-h="between">
      <b-col v-if="isShowUserPersonalVerification" :cols="12" lg="4">
        <card class="data-card" :show-footer-line="true">
          <b-row no-gutters>
            <b-col class="">
              <h1 class="card-header p-0 card-header-text pb-3">
                تایید اطلاعات اولیه کاربر
              </h1>
            </b-col>
          </b-row>
          <b-row no-gutters class="row-form pt-5 text-center">
            <b-col :cols="12">
              <div class="c-personal-info__data-wrapper-item">
                <span class="c-personal-info__data-wrapper-item__label">
                  موبایل :
                </span>
                <span class="c-personal-info__data-wrapper-item__value">
                  {{ userPersonalInfo.phoneNumber }}
                </span>
              </div>
              <div class="c-personal-info__data-wrapper-item">
                <span class="c-personal-info__data-wrapper-item__label">
                  کد ملی :
                </span>
                <span class="c-personal-info__data-wrapper-item__value">
                  {{ userPersonalInfo.nationalCode }}
                </span>
              </div>
              <div class="c-personal-info__data-wrapper-item">
                <span class="c-personal-info__data-wrapper-item__label">
                  تاریخ تولد :
                </span>
                <span class="c-personal-info__data-wrapper-item__value">
                  {{ userPersonalInfo.birthDay }}
                </span>
              </div>
            </b-col>


            <b-col v-if="userPersonalVerificationError" :cols="12">
              <b-alert variant="warning" show>
                خطا :
                {{ userPersonalVerificationError }}
              </b-alert>
            </b-col>

            <b-col
              :cols="12"
              class="d-flex align-items-center justify-content-start mt-3"
            >
              <b-button
                v-if="accessToUserDataActions"
                @click="$bvModal.show('reject-modal')"
                class="ml-3"
                variant="danger"
              >
                رد کردن
              </b-button>
              <b-button

                v-if="isShowPersonalInfoApproveButton && accessToUserDataActions"
                @click="$bvModal.show('approve-modal')"
                variant="success"
              >
                تایید کردن
              </b-button>
            </b-col>
          </b-row>
        </card>
      </b-col>

      <b-col
        v-if="isShowAddressRejectButton"
        :cols="12"
        :lg="isShowUserPersonalVerification ? 8 : 12"
      >
        <card class="data-card" :show-footer-line="true">
          <b-row no-gutters>
            <b-col class="">
              <h1 class="card-header p-0 card-header-text pb-3">
                تایید آدرس و کد پستی کاربر
              </h1>
            </b-col>
          </b-row>
          <b-row no-gutters class="row-form pt-5 text-center">
            <b-col :cols="12">
              <div class="c-personal-info__data-wrapper-item">
                <span class="c-personal-info__data-wrapper-item__label">
                  آدرس :
                </span>
                <span class="c-personal-info__data-wrapper-item__value">
                  {{ userAddress.address }}
                </span>
              </div>

              <div class="c-personal-info__data-wrapper-item">
                <span class="c-personal-info__data-wrapper-item__label">
                  کد پستی :
                </span>
                <span class="c-personal-info__data-wrapper-item__value">
                  {{ userAddress.postalCode }}
                </span>
              </div>
            </b-col>

            <b-col v-if="userAddressPostalCodeError" :cols="12">
              <b-alert variant="warning" show>
                خطا :
                {{ userAddressPostalCodeError }}
              </b-alert>
            </b-col>

            <b-col
              :cols="12"
              class="d-flex align-items-center justify-content-start mt-3"
            >
              <b-button
                v-if="accessToUserDataActions"
                @click="$bvModal.show('reject-address-modal')"
                class="ml-3"
                variant="danger"
              >
                رد کردن
              </b-button>
              <b-button
                v-if="isShowAddressApproveButton && accessToUserDataActions"
                @click="$bvModal.show('approve-address-modal')"
                variant="success"
              >
                تایید کردن
              </b-button>
            </b-col>
          </b-row>
        </card>
      </b-col>

    </b-row>

    <b-modal
      hide-footer
      class="text-right"
      title="رد کردن اطلاعات اولیه کاربر"
      id="reject-modal"
    >
      <h3 class="my-4">آیا مطمئن هستید ؟</h3>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('reject-modal')"
        >
          بستن
        </b-button>
        <base-button
          :loading="personalInfoRejectLoading"
          class="mt-2"
          type="success"
          @click="rejectUserPersonalInfo"
        >
          تایید
        </base-button>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      class="text-right"
      title="ویرایش و تایید کردن اطلاعات اولیه کاربر"
      id="approve-modal"
    >
      <div>
        <b-container fluid>
          <b-row class="my-1">
            <b-col sm="3">
              <label for="firstName"> نام </label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                v-model="userPersonalInfo.firstName"
                id="firstName"
                type="text"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3">
              <label for="lastName"> نام خانوادگی </label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                v-model="userPersonalInfo.lastName"
                id="lastName"
                type="text"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3">
              <label for="birthDate"> تاریخ تولد </label>
            </b-col>
            <b-col sm="9">
              <date-picker v-model="userPersonalInfo.birthDay" id="birthDate"/>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('approve-modal')"
        >
          بستن
        </b-button>
        <base-button
          :disabled="!isValidPersonalInfoForm"
          :loading="personalInfoApproveLoading"
          class="mt-2"
          type="success"
          @click="approveUserPersonalInfo"
        >
          تایید
        </base-button>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      class="text-right"
      title="رد کردن آدرس کاربر"
      id="reject-address-modal"
    >
      <h3 class="my-4">آیا مطمئن هستید ؟</h3>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('reject-address-modal')"
        >
          بستن
        </b-button>
        <base-button
          :loading="addressRejectLoading"
          class="mt-2"
          type="success"
          @click="rejectUserAddress"
        >
          تایید
        </base-button>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      class="text-right"
      title=" تایید کردن آدرس کاربر"
      id="approve-address-modal"
    >
      <div>
        <b-container fluid>
          <b-row class="my-1">
            <b-col sm="12">
              <label for="address"> آدرس </label>
            </b-col>
            <b-col sm="12" class="mb-4">
              <b-form-textarea
                v-model="userAddress.address"
                id="address"
                type="text"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3">
              <label for="postalCode"> کد پستی </label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                v-model="userAddress.postalCode"
                id="postalCode"
                type="text"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('approve-address-modal')"
        >
          بستن
        </b-button>
        <base-button
          :disabled="!isValidUserAddressForm"
          :loading="addressApproveLoading"
          class="mt-2"
          type="success"
          @click="approveUserAddress"
        >
          تایید
        </base-button>
      </div>
    </b-modal>


  </section>
</template>

<script>
import {
  approveAddress,
  approvePersonalInfo,
  getUserAccountVerification,
  getUserAddress,
  getUserPersonalInfo,
  rejectAddress,
  rejectPersonalInfo,
} from "@/httpservices/PersonalInfo";
import Swal from "sweetalert2";
import store from "@/store"
import http from "@/httpservices/HttpService"


export default {
  name: "PersonalInfo",

  data() {
    return {
      verifications: [],
      userPersonalInfo: {
        loading: true,
        phoneNumber: "",
        nationalCode: "",
        birthDay: "",
        firstName: "",
        lastName: "",
      },

      userAddress: {
        loading: true,
        address: "",
        postalCode: "",
      },

      personalInfoRejectLoading: false,
      personalInfoApproveLoading: false,
      addressRejectLoading: false,
      addressApproveLoading: false,
      isShowUserPersonalVerification: true,
      userPersonalVerificationError: null,
      userAddressPostalCodeError: null,
      isShowPersonalInfoApproveButton: true,
      isShowAddressApproveButton: false,
      isShowAddressRejectButton: false,
      account: {},


    };
  },

  methods: {
    async fetchUserPersonalInfo(accountId) {
      this.userPersonalInfo.loading = true;
      try {
        const {birthDate, cellPhone, nationalCode} = (
          await getUserPersonalInfo(accountId)
        ).data;
        this.userPersonalInfo = {
          ...this.userPersonalInfo,
          phoneNumber: String(cellPhone).split("-")[1] || "",
          nationalCode,
          birthDay: birthDate,
        };
      } catch (e) {
        this.userPersonalVerificationError = 'اطلاعات اولیه کاربر یافت نشد.'
        this.isShowPersonalInfoApproveButton = false;
        console.log({e});
      }
      this.userPersonalInfo.loading = false;
    },

    async fetchUserAddress(accountId) {
      const isApprovedUserAddress = this.verifications.filter((item) =>
        Boolean(
          item.step === "AddressPostalCode" && item.state === "Approved"
        )
      ).length || 0

      if (isApprovedUserAddress) {
        this.userAddress = {
          ...this.userAddress,
          address: this.account.address,
          postalCode: this.account.postalCode,
        };
        return
      }
      this.userAddress.loading = true;
      try {
        const {address, postalCode} = (await getUserAddress(accountId)).data;
        this.userAddress = {
          ...this.userAddress,
          address,
          postalCode,
        };

      } catch (e) {
        this.userAddressPostalCodeError = 'ادرس و کد پستی کاربر یافت نشد.';
        this.isShowAddressApproveButton = false;
        console.log({e});
      }
      this.userAddress.loading = false;
    },

    async rejectUserPersonalInfo() {
      try {
        this.personalInfoRejectLoading = true;
        await rejectPersonalInfo(this.$route.params.id);
        await Swal.fire({
          text: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "فهمیدم",
        });
        const accountId = this.$route.params.id;
        await this.fetchVerification(accountId);
      } catch (e) {
        console.log(e);
      }
      this.personalInfoRejectLoading = false;
      this.$bvModal.hide("reject-modal");
    },

    async approveUserPersonalInfo() {
      try {
        this.personalInfoApproveLoading = true;
        await approvePersonalInfo(this.$route.params.id, {
          ...this.userPersonalInfo,
          birthDate: this.userPersonalInfo.birthDay,
        });
        await Swal.fire({
          text: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "فهمیدم",
        });
        const accountId = this.$route.params.id;
        await this.fetchVerification(accountId);
      } catch (e) {
        const {title} = e.response.data;
        if (title === 'ENTITY_ALREADY_EXISTS') {
          await Swal.fire({
            text: 'این کد ملی قبلا در سیستم ثبت شده است.',
            icon: "error",
            confirmButtonText: "فهمیدم",
          });
        }
        console.log(e);
      }
      this.personalInfoApproveLoading = false;
      this.$bvModal.hide("approve-modal");
    },

    async rejectUserAddress() {
      try {
        this.addressRejectLoading = true;
        await rejectAddress(this.$route.params.id);
        await Swal.fire({
          text: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "فهمیدم",
        });
        const accountId = this.$route.params.id;
        await this.fetchVerification(accountId);
      } catch (e) {
        console.log(e);
      }
      this.addressRejectLoading = false;
      this.$bvModal.hide("reject-address-modal");
    },

    async approveUserAddress() {
      try {
        this.addressApproveLoading = true;
        await approveAddress(this.$route.params.id, this.userAddress);
        await Swal.fire({
          text: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "فهمیدم",
        });
        const accountId = this.$route.params.id;
        await this.fetchVerification(accountId);
      } catch (e) {
        console.log(e);
      }
      this.addressApproveLoading = false;
      this.$bvModal.hide("approve-address-modal");
    },

    async fetchVerification(accountId) {
      try {
        this.verifications =
          (await getUserAccountVerification(accountId)).data || [];


        this.verifications.forEach(item => {
          if (item.step === "AddressPostalCode") {
            this.userAddressStatus = item.state
          }
        })

        this.isShowAddressApproveButton = Boolean(
          this.verifications.filter((item) =>
            Boolean(
              item.step === "AddressPostalCode" && item.state === "InProgress"
            )
          ).length || 0
        );

        this.isShowAddressRejectButton = Boolean(
          this.verifications.filter((item) =>
            Boolean(item.step === "AddressPostalCode" && item.state === "InProgress" ) ||
            Boolean(item.step === "AddressPostalCode" && item.state === "Approved" )
          ).length || 0
        );


        this.isShowUserPersonalVerification = Boolean(
          this.verifications.filter((item) =>
            Boolean(item.step === "PersonalInfo" && item.state === "InProgress")
          ).length || 0
        );
      } catch (e) {
        console.log(e);
      }
    },

    getAccount() {
      const token = localStorage.getItem("token") || "";
     http.get("/Accounts/" + this.$route.params.id,)
        .then((response) => {
          this.account = response.data;
        })
        .catch((err) => {

        });
    },
  },

  mounted() {
    this.$nextTick(async () => {
      const accountId = this.$route.params.id;
      await this.getAccount();
      await this.fetchVerification(accountId);
      this.isShowUserPersonalVerification &&
      (await this.fetchUserPersonalInfo(accountId));

      await this.fetchUserAddress(accountId);
    });
  },

  computed: {
    isValidPersonalInfoForm() {
      return Boolean(
        this.userPersonalInfo.birthDay &&
        this.userPersonalInfo.firstName &&
        this.userPersonalInfo.lastName &&
        !this.userPersonalInfo.loading
      );
    },

    isValidUserAddressForm() {
      return Boolean(
        this.userAddress.address &&
        this.userAddress.postalCode &&
        !this.userAddress.loading
      );
    },

    accessToUserDataActions() {
      return Boolean(
        store.getters['isSuperAdmin'] ||
        store.getters['isApprovingManager']
      );
    }
  },
};
</script>

<style lang="scss">
.modal-header .close {
  padding: 0;
  margin: 0;
}

.modal-body {
  text-align: right;
}

.c-personal-info {
  &__data-wrapper-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 15px;
    border-radius: 5px;
    background-color: #eee;
    width: 100%;
    margin-bottom: 10px;

    &__label {
      font-weight: bold;
      font-size: 1rem;
      display: flex;
      width: max-content;
      padding-left: 15px;
    }

    &__value {
      opacity: 0.7;
      font-weight: normal;
      font-size: 0.9rem;
      display: flex;
      width: 50%;
    }
  }
}
</style>
